import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import {
  ProductCountryActionsUnion,
  ProductCountryActionTypes
} from '@core/actions/product-country.actions';

import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  ProductActionTypes,
  ProductActionsUnion
} from '@core/actions/product.actions';

import { Product, ProductCountry } from '@app/models';
import { AuthActionsUnion, AuthActionTypes } from '../actions/auth.actions';

export interface State extends EntityState<ProductCountry> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<ProductCountry> = createEntityAdapter<
  ProductCountry
>({
  selectId: (productCountry: ProductCountry) => productCountry.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ProductCountryActionsUnion | AuthActionsUnion | ProductActionsUnion
) {
  switch (action.type) {
    case ProductCountryActionTypes.LoadByProductSuccess:
    case ProductCountryActionTypes.LoadByFollowSuccess:
    case ProductCountryActionTypes.UpsertMany:
    case ProductCountryActionTypes.LoadByProductMirrorSuccess:
      return adapter.upsertMany(action.countries, state);

    case ProductCountryActionTypes.UpdateOne:
      return adapter.updateOne(
        { id: action.productCountry.id, changes: action.productCountry },
        state
      );
    case ProductCountryActionTypes.UpdateMany:
      return adapter.updateMany(
        action.productCountries.map(productCountry => {
          return { id: productCountry.id, changes: productCountry };
        }),
        state
      );
    case ProductCountryActionTypes.BulkUpdate:
      return { ...state, updating: true };

    case ProductCountryActionTypes.BulkUpdateSuccess:
      return adapter.upsertMany(action.productCountries, state);

    case AuthActionTypes.Logout:
      return INITIAL_STATE;

    case ProductActionTypes.Clear:
    case ProductCountryActionTypes.Clear:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getState = createFeatureSelector<State>('productCountries');

export const getProductCountryMirrors = createSelector(
  getState,
  selectAll
);
